import React from 'react'

import Drawer from '@material-ui/core/Drawer'
import ListItem from '@material-ui/core/ListItem'
import Typography from '@naturacosmeticos/natds-web/dist/Components/Typography'
import Divider from '@material-ui/core/Divider'
import Link from '@material-ui/core/Link'
import List from '@material-ui/core/List'
import ListItemText from '@material-ui/core/ListItemText'

import withStyles from '@material-ui/core/styles/withStyles'
import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl'
import useDataLayer from '../../hooks/useDataLayer'

const styles = theme => ({
  divider: { margin: '15px 0' },
  list: {
    backgroundColor: theme.palette.common.white,
    maxWidth: '320px',
    width: '85%'
  },
  listItem: { paddingLeft: '24px' },
  listItemLink: { outline: 0, width: '100%' },
  listItemText: { fontSize: '0.875rem' },
  slogan: {
    color: '#333333',
    fontSize: '20px',
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: '500',
    letterSpacing: '0.24px',
    lineHeight: 1.2,
    margin: '56px 40px 16px 0',
    maxWidth: '240px',
    minHeight: '72px',
    textAlign: 'left'
  }
})

const NavigationDrawer = ({
  classes,
  opened,
  onClose,
  menuItems,
  intl,
  ...props
}) => {
  const dataLayer = useDataLayer()

  const pushDataLayer = item => {
    dataLayer.push({
      event: 'navigationClick',
      sectionId: intl.formatMessage({ id: item.gtmLabel }),
      buttonText: intl.formatMessage({ id: item.label })
    })
  }

  return (
    <Drawer
      ModalProps={{ disableScrollLock: true }}
      classes={{ paper: classes.list }}
      component="nav"
      open={opened}
      onClose={onClose}
      {...props}
    >
      <ListItem classes={{ gutters: classes.listItem }}>
        <Typography classes={{ root: classes.slogan }} variant="h6">
          <FormattedHTMLMessage id="homeHeroTitle" />
        </Typography>
      </ListItem>
      <Divider classes={{ root: classes.divider }} />
      <nav itemScope itemType="http://schema.org/SiteNavigationElement">
        <List component="ul">
          {Array.isArray(menuItems) &&
            menuItems.map(item => (
              <ListItem
                id={`${item.id}-drawer-menu-item`}
                classes={{ gutters: classes.listItem }}
                component="li"
                key={item.href}
                itemProp="name"
              >
                <Link
                  classes={{ root: classes.listItemLink }}
                  color="inherit"
                  href={item.href}
                  itemProp="url"
                  onClick={() => {
                    pushDataLayer(item)
                    onClose()
                  }}
                  data-gtm-category-ga4="landing_header"
                  data-gtm-main-action-ga4="click"
                  data-gtm-label-ga4={intl.formatMessage({ id: item.label })}
                >
                  <ListItemText
                    classes={{ primary: classes.listItemText }}
                    primary={<FormattedMessage id={item.label} />}
                  />
                </Link>
              </ListItem>
            ))}
        </List>
      </nav>
      <Divider classes={{ root: classes.divider }} />
      <List>
        <ListItem classes={{ gutters: classes.listItem }}>
          <ListItemText>
            <Link
              href="tel:03007628872"
              color="inherit"
              classes={{ root: classes.listItemText }}
              data-gtm-category-ga4="landing_header"
              data-gtm-main-action-ga4="click"
              data-gtm-label-ga4={intl.formatMessage({ id: "phone" })}
            >
              <FormattedHTMLMessage id="phone" />
            </Link>
          </ListItemText>
        </ListItem>
      </List>
    </Drawer>
  )
}

export default withStyles(styles)(injectIntl(NavigationDrawer))
